module.exports = __webpack_public_path__ + "static/media/heroimg.f29237cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/main/heroimg.svg
// module id = 62
// module chunks = 0